import { render } from "./IconLoading.vue?vue&type=template&id=3a727ab0&ts=true"
import script from "./IconLoading.vue?vue&type=script&lang=ts"
export * from "./IconLoading.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__